export default __webpack_public_path__ + "static/Celebration-0a030682d1023796ce09aaa1c4737a49.png";